export default __webpack_public_path__ + "static/media/comming-soon.6ede5975.svg";